import Button from '@platform-ui-common/components/Button/index.js';
import FormContainer from '@platform-ui-common/components/FormContainer/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import usePartner from '@platform-ui-common/hooks/contexts/usePartner.js';
import Color, { BackgroundColors } from '@platform-ui-common/utilities/Color.js';
import ApplicantRoutes from '@platform-ui/application/utils/ApplicantRoutes.js';
import useAuth from '@platform-ui/auth/hooks/useAuth/index.js';

export default function ErrorScreen(): JSX.Element {
  const { user } = useAuth();
  const partner = usePartner();
  if (!partner)
    return (
      <div className="w-full h-full flex-grow flex flex-col items-center">
        <Typography variant="h2" alignment="center">
          <b>404:</b> Page Not Found
        </Typography>
      </div>
    );
  return (
    <>
      <div className="grid grid-cols-2 absolute w-full h-full inset-0">
        <div />
        <div className={`${BackgroundColors[Color.LightBackground]} rounded-r-[10px]`} />
      </div>
      <FormContainer
        title="Sorry, we can’t find that page"
        buttons={
          user && (
            <Button link={ApplicantRoutes.APPLICATION_PORTAL}>Go to Application Portal</Button>
          )
        }
      >
        <Typography variant="h2">404: Page not found</Typography>
        <div className="lg:w-1/2 text-center">
          <Typography variant="body">
            We can&apos;t seem to find the page you&apos;re looking for.{' '}
            {user &&
              'Select the Go to Application Portal button to go to your Application Portal and continue your application.'}
          </Typography>
        </div>
      </FormContainer>
    </>
  );
}
